import { PointConversionInfoCard } from './PointConversionInfoCard'
import { SelectCreditAmount } from './SelectCreditAmount'
import { PointsRedemptionConfirmationInfoCard } from './PointsRedemptionConfirmationInfoCard'

export const PointsRedemption = {
  PointConversionInfoCard: PointConversionInfoCard,
  SelectCreditAmount: SelectCreditAmount,
  PointsRedemptionConfirmationInfoCard: PointsRedemptionConfirmationInfoCard,
}
